import { HatElement } from '@/components/hat-element.js';

class HatPrivateBeta extends HatElement {
    connectedCallback() {
    super.connectedCallback();
    this.root.innerHTML = `
            <style>
                :host {
                    display: block;
                    width: 100%;
                    margin: 16px 0;
                }

                .banner {
                    position: relative;
                    overflow: hidden;

                    display: flex;
                    align-items: center;
                    gap: 16px;

                    padding: 18px 22px;

                    border-radius: 18px;

                    background:
                        linear-gradient(
                            135deg,
                            rgba(255, 193, 7, 0.95),
                            rgba(255, 152, 0, 0.92)
                        );

                    color: #2b1d00;

                    box-shadow:
                        0 8px 24px rgba(0,0,0,0.18),
                        inset 0 1px 0 rgba(255,255,255,0.35);

                    border: 1px solid rgba(255,255,255,0.25);

                    backdrop-filter: blur(10px);
                }

                .banner::before {
                    content: "";
                    position: absolute;
                    inset: 0;

                    background:
                        linear-gradient(
                            120deg,
                            rgba(255,255,255,0.18),
                            transparent 35%,
                            transparent 65%,
                            rgba(255,255,255,0.10)
                        );

                    pointer-events: none;
                }

                .icon {
                    flex-shrink: 0;

                    width: 52px;
                    height: 52px;

                    border-radius: 14px;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    background: rgba(255,255,255,0.22);

                    font-size: 28px;

                    box-shadow:
                        inset 0 1px 0 rgba(255,255,255,0.35),
                        0 2px 8px rgba(0,0,0,0.12);
                }

                .content {
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                    min-width: 0;
                }

                .title {
                    font-size: 18px;
                    font-weight: 700;
                    letter-spacing: 0.3px;

                    text-shadow:
                        0 1px 2px rgba(255,255,255,0.35);
                }

                .message {
                    font-size: 14px;
                    line-height: 1.5;

                    color: rgba(43, 29, 0, 0.88);
                }

                .pill {
                    margin-top: 6px;

                    width: fit-content;

                    padding: 6px 12px;

                    border-radius: 999px;

                    background: rgba(0,0,0,0.12);

                    font-size: 12px;
                    font-weight: 700;
                    letter-spacing: 0.8px;
                    text-transform: uppercase;

                    backdrop-filter: blur(6px);
                }

                @media (max-width: 600px) {
                    .banner {
                        padding: 16px;
                        gap: 12px;
                        align-items: flex-start;
                    }

                    .icon {
                        width: 46px;
                        height: 46px;
                        font-size: 24px;
                    }

                    .title {
                        font-size: 16px;
                    }

                    .message {
                        font-size: 13px;
                    }
                }
            </style>

            <div class="banner">
                <div class="icon">⚠️</div>

                <div class="content">
                    <div class="title">
                        Private Beta Access
                    </div>

                    <div class="message">
                        Home Asset Tracker is currently in private beta and is
                        still under active development. Features may change,
                        data may be reset, and some functionality may be
                        incomplete or unstable.
                    </div>

                    <div class="pill">
                        Not Ready For Public Use
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('hat-private-beta', HatPrivateBeta);